// extracted by mini-css-extract-plugin
export var mt0 = "simple-header-module--mt-0--d3151";
export var mt1 = "simple-header-module--mt-1--bc27b";
export var mt2 = "simple-header-module--mt-2--32a4e";
export var mt3 = "simple-header-module--mt-3--77494";
export var mt4 = "simple-header-module--mt-4--6d091";
export var mt5 = "simple-header-module--mt-5--10ac3";
export var mt6 = "simple-header-module--mt-6--931d2";
export var simpleHeader = "simple-header-module--simple-header--6a4f9";
export var simpleHeader__body = "simple-header-module--simple-header__body--afb9e";
export var simpleHeader__logo = "simple-header-module--simple-header__logo--54bb2";
export var simpleHeader__logoWrapper = "simple-header-module--simple-header__logo-wrapper--50c60";
export var simpleHeader__product = "simple-header-module--simple-header__product--14194";
export var simpleHeader__wrapper = "simple-header-module--simple-header__wrapper--78407";